import { DocumentModel } from '../../../../shared/models/simple-types/document.model';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ChangeDetectorRef, Component, HostListener, Inject, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BcComponentsService } from '../../bc-components.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { validatorFileSize, validatorFileType } from 'src/app/shared/fileValidators';
import * as moment from 'moment';

export interface DialogData {
  idBc: number;
  documents: DocumentModel[];
}

export class ImportResult {
  nbBc: number;
  saveAllBc: string;
  setAllBc: string;
  setAllBcLigne: string;
  totalHt: number;
}

@Component({
  selector: 'app-modal-import-bc',
  templateUrl: './modal-import-bc.component.html',
  styleUrls: ['./modal-import-bc.component.scss'],
})

export class ModalImportBcComponent implements OnInit {

  public bcImportform: UntypedFormGroup;
  file: File;
  state: number;
  progress = 0;
  ext: string;
  fileControl: UntypedFormControl;
  stateControl: UntypedFormControl;
  result: ImportResult;

  canImportValide = false;
  canImportNonProv = false;
  canImportProv = false;

  submitted = false;
  received = false;
  constructor(
    public dialog: MatDialog,
    private toastr: ToastrService,
    public router: Router,
    private bcComponentsService: BcComponentsService,
    public dialogRef: MatDialogRef<Component>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private changeDetectorRef: ChangeDetectorRef) {
    this.fileControl = new UntypedFormControl(null, [Validators.required, validatorFileType("csv"),validatorFileSize(20000000)]);
    this.stateControl = new UntypedFormControl(null, [Validators.required, Validators.min(0), Validators.max(2)]);
    this.bcImportform = new UntypedFormGroup({
      file: this.fileControl,
    });
    const user = JSON.parse(localStorage.getItem('CURRENT_USER'));  
  }
  ngOnInit(): void {
  }

  onModalCancel(): void {
    this.dialogRef.close(this.result);
  }

  onSubmit(): void {
    if (this.bcImportform.valid) {

      this.file = this.fileControl.value;     
      this.submitted = true;
      this.bcComponentsService
        .sendImportedBc(this.file)
        .subscribe(obj => {
          this.toastr.success('BC importé');
          this.received = true;
          this.result = obj as any;
        }, error => {
          this.submitted = false;
      });
    }else{
      this.toastr.error('Fichier non valide');

    }
  }
}
